import styled from "styled-components";

export const PopupContainer = styled.div`
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: rgba(0,0,0,0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;

    > div {
        width: 90%;
        max-width: 460px;
        max-height: 70vh;
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 8px 30px rgba(0,0,0,0.15);
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .header {
        height: 52px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 17px;
        font-weight: 600;
        font-family: S-Core-Dream;
        color: #212529;
        border-bottom: 1px solid #e9ecef;
        position: relative;

        .closeBtn {
            position: absolute;
            right: 16px;
            cursor: pointer;
            width: 28px;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            transition: background 0.15s;
            &:hover { background: #e9ecef; }
            img { height: 16px; }
        }
    }

    .body {
        overflow-y: auto;
        flex: 1;
        padding: 12px 16px;

        .locationItem {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 12px;
            margin-bottom: 8px;
            background: #f8f9fa;
            border-radius: 8px;
            font-size: 14px;
            color: #495057;
            font-family: S-Core-Dream;

            .delBtn {
                width: 28px;
                height: 28px;
                min-width: 28px;
                border: 1px solid #dee2e6;
                border-radius: 6px;
                background: #fff;
                color: #dc3545;
                font-size: 16px;
                font-weight: 700;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 8px;
                transition: background 0.15s;
                &:hover {
                    background: #dc3545;
                    color: #fff;
                    border-color: #dc3545;
                }
            }
        }

        .addBtn {
            display: block;
            width: 100%;
            padding: 10px;
            background: #0d6efd;
            color: #fff;
            border: none;
            border-radius: 8px;
            font-size: 14px;
            font-family: S-Core-Dream;
            font-weight: 600;
            cursor: pointer;
            margin-top: 4px;
            transition: background 0.2s;
            &:hover { background: #0b5ed7; }
        }
    }
`;
